import { UserCalendar } from '@/services/undergrad/pegasus-epona/user-calendar.service';

export interface CalendarState {
  userCalendar?: UserCalendar;
  isConnectingCalendar: boolean;
}

const state: CalendarState = {
  userCalendar: undefined,
  isConnectingCalendar: false,
};

export default state;
